<template>
  <AdminBanner v-if="isAdmin" />
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
  <BaseToast />
</template>
<script>
import { mapGetters } from "vuex";
import BaseToast from "./components/basic/BaseToast.vue";
import AdminBanner from "./components/basic/AdminBanner.vue";
export default {
  name: "App",
  components: {
    BaseToast,
    AdminBanner,
  },
  computed: {
    ...mapGetters("sessions", ["user", "trueUser"]),
    ...mapGetters(["adminBannerHidden"]),
    isAdmin() {
      const user = this.trueUser || this.user;
      return (
        user &&
        (user.role === "company_admin" ||
          user.role === "super_admin" ||
          user.role_type === "company_admin" ||
          user.role_type === "super_admin")
      );
    },
    darkTheme() {
      return this.user?.plan_preferences?.dark_theme === true;
    },
  },
  watch: {
    darkTheme(newValue) {
      this.applyTheme(newValue);
    },
    user: {
      handler() {
        // Apply theme when user data is loaded or updated
        this.applyTheme(this.darkTheme);
      },
      immediate: true,
    },
  },
  mounted() {
    // Apply theme on mount in case user is already loaded
    this.applyTheme(this.darkTheme);
    const flashMessage = document.getElementById("app").dataset.flashMessage;
    if (flashMessage) {
      this.$store.dispatch("showToast", {
        type: "success",
        message: flashMessage,
      });
    }
  },
  methods: {
    applyTheme(isDark) {
      if (isDark) {
        document.documentElement.setAttribute("data-theme", "dark");
      } else {
        document.documentElement.removeAttribute("data-theme");
      }
    },
  },
};
</script>
